import findResult from '@/utils/resultsHelper';
import pagingWithFilteredResults from '@/constants/states';
import defaultStates, { readStates, states } from '@/constants/lifecycle';
import { formSections } from '@/forms/state/state';
import { catalogueSectionNames } from '../constants';

export const cataloguePanels = (openPanels = [0]) => ({
  panels: {
    single: openPanels,
    left: openPanels,
    middle: openPanels,
    right: openPanels,
  },
});

export const catalogueSections = (names = catalogueSectionNames) => {
  const sections = { sections: {} };
  names.forEach((name) => {
    sections.sections[name] = { label: '', fields: [] };
  });

  return sections;
};

export const findCatalogueTemplates = ({ templates }, { category }) => templates[category];

export const findCatalogueTemplate = ({ templates }, { category, code }) => (
  findResult(templates, category, code)
);

const activeFilters = (enabledFlag = true, disabledFlag = true) => ({
  enabledFlag,
  disabledFlag,
});

export const allTemplates = (enabledFlag, disabledFlag) => ({
  all: {
    ...pagingWithFilteredResults(),
    ...activeFilters(enabledFlag, disabledFlag),
    ...defaultStates,
    multiSelect: true,
  },
});

const initialState = {
  templates: {
    lookups: {
      enabledFlag: true,
      disabledFlag: false,
      results: [],
      ...readStates,
    },
    open: {
      results: [],
    },
  },
};

export const openCatalogueTemplate = ({ code }) => ({
  code,
  ...catalogueSections(),
  readStatus: states.PENDING,
  readErrors: [],
  ...cataloguePanels(),
  copy: {},
  asViewer: {
    on: false,
    uuid: null,
  },
});

export const blankCatalogueTemplate = () => ({ ...readStates, ...formSections() });

export default initialState;
